import React, { Component } from 'react';
import { gsap } from 'gsap';
import ReactDOM from 'react-dom';

import config from '@config';
import ChannelList from '@tvguide/components/channellist';
import ChannelColumn from './channelcolumn';

class ListView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isScrolling: false,
    };

    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.debouncedTimeout;
  }

  componentDidMount() {
    window.dispatchEvent(new Event(config.events.renderedGrid));
  }

  componentDidUpdate(prevProps, prevState) {
    window.dispatchEvent(new Event(config.events.renderedGrid));
    if (prevState.isScrolling !== this.state.isScrolling) {
      this.toggleScrolling(this.state.isScrolling);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.onMouseMove);
    window.removeEventListener('mouseup', this.onMouseUp);
  }

  toggleScrolling(isEnable) {
    if (isEnable) {
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('mouseup', this.onMouseUp);
    } else {
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('mouseup', this.onMouseUp);
    }
  }

  onMouseMove(event) {
    const { clientX, scrollLeft, scrollTop, clientY } = this.state;
    this._scroller.scrollLeft = scrollLeft - clientX + event.clientX;
    this._scroller.scrollTop = scrollTop - clientY + event.clientY;
  }

  onMouseUp(e) {
    this.setState({
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0,
      clientX: 0,
      clientY: 0,
    });

    this.onScrollEnd();
  }

  onMouseDown(event) {
    const { scrollLeft, scrollTop } = this._scroller;
    this.setState({
      isScrolling: true,
      scrollLeft,
      scrollTop,
      clientX: event.clientX,
      clientY: event.clientY,
    });
  }

  attachScroller(scroller) {
    this._scroller = ReactDOM.findDOMNode(scroller);
  }

  handleScroll(e) {
    clearTimeout(this.debouncedTimeout);
    this.debouncedTimeout = setTimeout(this.onScrollEnd.bind(this, e), 500);
  }

  onScrollEnd() {
    const offset = window.pageYOffset;
    window.scroll(0, offset + 1);
    window.scroll(0, offset);
  }

  handleNavClick(direction) {
    const gapSize = window.innerWidth > config.breakpoints.tablet ? 600 : 250;
    const distance = direction > 0 ? gapSize : gapSize * -1;
    gsap.to(this._scroller, 0.5, {
      scrollLeft: this._scroller.scrollLeft + distance,
    });
  }

  render() {
    return (
      <div className="tvg-list-view__wrapper" style={{ position: 'relative' }}>
        <div className="tvg-list-view__nav fv-carousel">
          <div
            className="tvg-list-view__nav__cta tvg-list-view__nav__cta--left"
            onClick={this.handleNavClick.bind(this, -1)}
          >
            <span className="fv-directional-cta fv-directional-cta--left" />
          </div>
          <div
            className="tvg-list-view__nav__cta tvg-list-view__nav__cta--right"
            onClick={this.handleNavClick.bind(this, 1)}
          >
            <span className="fv-directional-cta fv-directional-cta--right" />
          </div>
        </div>
        <div
          className="tvg-list-view__container"
          ref={this.attachScroller.bind(this)}
          onMouseDown={this.onMouseDown.bind(this)}
          onScroll={this.handleScroll.bind(this)}
        >
          <div className="tvg-list-view">
            <ChannelList />
            <div className="tvg-list-view__channel-container">
              {this.props.channels.map(c => (
                <ChannelColumn
                  key={c.service_id}
                  sid={c.service_id}
                  channelPrograms={c.programs}
                  id={c.service_id}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ListView;
